module.exports = __webpack_public_path__ + "media/categories/205-782af9aa.svg";